module.exports = {
  aws_cognito_region: "us-east-2", // (required) - Region where Amazon Cognito project was created
  aws_user_pools_id: "us-east-2_RoalZLddD", // (optional) - Amazon Cognito User Pool ID
  aws_user_pools_web_client_id: "1d1jtlojlgmttsrt634uns59mr",
  aws_mandatory_sign_in: "enable"
};


  // aws_user_pools_id: "us-east-2_RoalZLddD", // (optional) - Amazon Cognito User Pool ID
  // aws_user_pools_web_client_id: "62lp4ced9l2svdvj6b58edb06a",
